var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 order-info-attachment-docs",attrs:{"fluid":""}},[_c('order-attachment-documents',{staticClass:"page-content",attrs:{"order":_vm.order}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }